// WhatWeSupport.js
import React from 'react';
import { motion } from 'framer-motion';
import { UserCheck, Target, Calendar, MessageSquare, FileText, Headphones } from 'lucide-react';

const WhatWeSupport = () => {
  const services = [
    {
      icon: UserCheck,
      title: 'Eligibility Assessment and Screening',
      description: 'Thorough evaluation of your qualifications and readiness for international employment',
      color: 'border-blue-500'
    },
    {
      icon: Target,
      title: 'Role Matching',
      description: 'Matching candidates with suitable positions based on experience and availability',
      color: 'border-green-500'
    },
    {
      icon: Calendar,
      title: 'Interview Scheduling',
      description: 'Coordinating interview slots with partner employers based on candidate readiness',
      color: 'border-purple-500'
    },
    {
      icon: MessageSquare,
      title: 'Interview Preparation and Coaching',
      description: 'Comprehensive preparation materials and guidance to ensure interview readiness',
      color: 'border-orange-500'
    },
    {
      icon: FileText,
      title: 'Documentation and Compliance Guidance',
      description: 'Support with required documentation and compliance requirements',
      color: 'border-red-500'
    },
    {
      icon: Headphones,
      title: 'Ongoing Support',
      description: 'Continuous guidance and support throughout the entire hiring process',
      color: 'border-teal-500'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            What We Support
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            We focus on preparation, coordination, and professional readiness
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className={`bg-white border-t-4 ${service.color} p-6 hover:shadow-lg transition-shadow`}
              >
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#F5F8FA] rounded-lg flex items-center justify-center">
                    <Icon size={24} className="text-[#202356]" />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-[#202356] mb-2">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm font-light">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeSupport;
